/**
 * Created by OLD on 30/10/2015.
 */
define('superAdminLayoutController',[
  'module',
  'logger',
  'underscore',
  'app',
  'backbone',
  'superAdminLayoutView'
], function(
  module,
  Logger,
  _,
  App,
  Backbone,
  View
) {
  'use strict';

  var SuperAdminController = {
    showLayoutSuperAdmin: function(tab) {
      var defer = $.Deferred(),
        view;

      if (true === true) {
        view = new View({tab: tab});
        this.view = view;
        view.listenTo(view, 'onChangeTab', _.bind(this.onChangeTab, this));

        App.regions.getRegion('main').currentView.getRegion('content').show(view);
        defer.resolve();
      } else {
        defer.resolve();
      }
      return defer.promise();
    },

    onChangeTab: function(tab) {
      App.navigate('superAdmin/' + tab, {trigger: true});
    }
  };

  module.exports = SuperAdminController;
});
